import { message } from "antd";
import { PatientDetailsResponse } from "../models/PatientModels";
import moment from "moment";

export class Utility {

    public static downloadBase64File(base64Data: string, fileName: string, contentType: string) {
        // Convert base64 to raw binary data
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });

        // Create temporary link and trigger download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Release memory
        URL.revokeObjectURL(link.href);
    }

    public static delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    public static checkWarnings = (warning: any) => {
      
        for (const [areaKey, areaValue] of Object.entries(warning) as [string, any]) {         
           for (const [fieldKey, fieldValue] of Object.entries(areaValue) as [string, any]) {            
              if (fieldValue.showWarning){
                 return true;
              }
           }
         }
        
        return false;
     }

    public static isNullOrUndefined(obj: any|void): boolean {
        return typeof obj === 'undefined' || obj === null;
    }

    public static isNullOrUndefinedOrEmpty(obj: any|void): boolean {
        if (Utility.isNullOrUndefined(obj)) {
            return true;
        }
        if (typeof(obj) === 'string' || obj instanceof String) {
            return (obj as string).valueOf() === '';
        } else if (obj instanceof Array) {
            return (obj as Array<any>).length === 0;
        }
        throw new Error('Not Supported Exception');
    }

    public static getStringOrNa = (str: string | null | undefined) => {
        return Utility.isNullOrUndefinedOrEmpty(str) ? "N/A" : str;
    }

    public static checkNullOrUndefined = (fields: any) => {
        const mandatoryFields = fields.filter((item: any) => item.mandatory);
        return mandatoryFields.some(
           (field: any) =>
              field.value === null ||
              field.value === undefined ||
              field.value === '',
        );
     };

    public static errorToast = (msg: any) => {
        message.error(msg);
    };

    public static getFormattedDate = (stringDate?: string) => {
        return Utility.isNullOrUndefinedOrEmpty(stringDate) ? "N/A" : moment(stringDate).format('MM/DD/YY');
    }

    public static getFormattedDateTime = (date: string) => {
        date = Utility.identifyDateAsUtc(date);

        const localTime = new Date(date).toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            });
        
        return localTime;
    }

    public static getFormattedDateTime2 = (date: string) => {
        date = Utility.identifyDateAsUtc(date);
        return moment(new Date(date)).format('M/D/YYYY HH:mm')
    }

    public static getDemographicChangesCount = (fields: any, patientDetails: PatientDetailsResponse) => {
        const demographicKeysCount = 3; //['firstName', 'lastName', 'dateOfBirth'];
        const newFirstName = fields.filter((item: any) => item.key === 'firstName')[0];
        const newLastName = fields.filter((item: any) => item.key === 'lastName')[0];
        const newDOB = fields.filter((item: any) => item.key === 'dateOfBirth')[0];
        
        let count: number = 0;

        if (patientDetails.demographics.firstName !== newFirstName.value)   count++;
        if (patientDetails.demographics.lastName !== newLastName.value)   count++;
        if (patientDetails.demographics.dateOfBirth !== newDOB.value)   count++;
        
        return count;
     };

     // use only if you know the date is UTC, but not specified as such
    public static identifyDateAsUtc = (dateString: string) => {

        if (Utility.isNullOrUndefinedOrEmpty(dateString)) {
            return "N/A"
        }

        if (dateString[dateString.length-1] === 'Z') return dateString;

        return `${dateString}Z`
    }
}
